module.exports = __webpack_public_path__ + "img/tjjj.7f3bc732.jpg";